import { GLOBALS } from '../globals'
import { createInputTextComponents } from '../setup-factories'

const INPUT_TEXT_SETTINGS = {
  input: {
    height: '41px',
    background: { color: '#ffffff' },
    font: GLOBALS.font.default,
    border: { width: '1px', style: 'solid', color: GLOBALS.color.grey[600], radius: '3px' },
    padding: { top: '10px', right: '14px', bottom: '8px', left: '14px' },
    placeholderColor: 'black',
    transition: { all: GLOBALS.transition.default }
  },
  $when: {
    focus: {
      input: { border: { color: GLOBALS.color.grey[500] } }
    },
    invalid: { input: { border: { color: GLOBALS.color.grey[500] } } },
    disabled: {
      input: { background: { color: GLOBALS.color.grey[500] }, border: { color: GLOBALS.color.grey[500] } }
    },
    readonly: {
      input: {
        font: { color: GLOBALS.color.grey[500] },
        background: { color: GLOBALS.color.grey[500] },
        border: { color: GLOBALS.color.grey[500] }
      }
    }
  }
} as const

export const { InputText } = createInputTextComponents(
  {
    ...INPUT_TEXT_SETTINGS
  },
  {}
)
